// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"5314770d67f4a69d","251":"4d916dd2ef2ea8fb","337":"ac356761b39e3f7e","500":"39668e6880dee71c"}[chunkId] + ".js";
};